// Recidiviz - a data platform for criminal justice reform
// Copyright (C) 2026 Recidiviz, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.
// =============================================================================

import { DocumentData } from "@google-cloud/firestore";

import {
  UsTxEarlyReleaseFromSupervisionV2Record,
  usTxEarlyReleaseFromSupervisionV2Schema,
} from "~datatypes";

import { OpportunityUpdateWithForm } from "../../../../FirestoreStore";
import { Client } from "../../../Client";
import { UsTxEarlyReleaseFromSupervisionV2Form } from "../../Forms/UsTxEarlyReleaseFromSupervisionV2Form/UsTxEarlyReleaseFromSupervisionV2Form";
import { UsTxArsErsV2OpportunityBase } from "../UsTxArsErsV2OpportunityBase";
import type { UsTxEarlyReleaseFromSupervisionV2DraftData } from "../UsTxDraftData";

export class UsTxEarlyReleaseFromSupervisionV2Opportunity extends UsTxArsErsV2OpportunityBase<
  UsTxEarlyReleaseFromSupervisionV2Record["output"],
  OpportunityUpdateWithForm<UsTxEarlyReleaseFromSupervisionV2DraftData>
> {
  form: UsTxEarlyReleaseFromSupervisionV2Form;

  constructor(client: Client, record: DocumentData) {
    super(
      client,
      "usTxEarlyReleaseFromSupervisionV2",
      client.rootStore,
      usTxEarlyReleaseFromSupervisionV2Schema.parse(record),
    );

    this.form = new UsTxEarlyReleaseFromSupervisionV2Form(this, this.rootStore);
  }
}
